import React from "react";

import TwoRowDownSingle from "./TwoRowDownSingle";

const GreyBlock = ({ label, bgClass, data = {}, lChecker, rChecker, rClassName = "", lClassName = "" }) => {
    let keys = data !== null && data !== undefined ? Object.keys(data) : [],
        maxIndex = keys.length - 1;

    return (
        <>
            <label className="fw-600 text-16">{label}</label>
            {keys.length ? (
                <div style={{ borderColor: "#ececec" }} className={`border-radius p-4 mt-3 ${bgClass}`}>
                    {keys.map((key, index) => (
                        <TwoRowDownSingle
                            key={key}
                            className={maxIndex === index ? "" : "mb-6"}
                            lClassName={lClassName ? lClassName : "fw-500 text-14 secondary-light-color"}
                            left={typeof lChecker === "function" ? lChecker(key) : key}
                            rClassName={rClassName ? rClassName : "text-16 fw-500 secondary-light-color"}
                            right={typeof rChecker === "function" ? rChecker(data[key]) : data[key]}
                        />
                    ))}
                </div>
            ) : (
                <div className={`border-radius p-4 mt-3 ${bgClass}`}>----</div>
            )}
        </>
    );
};

export default GreyBlock;
